import * as React from 'react';
import {useState} from 'react';
import {ThumbNailModel} from "features/apartmentViewer/ApartmentViewer/models/ThumbNailModel";

import './style.scss';
import {ApartmentThumbLoader} from "features/apartmentViewer/components/ApartmentThumbs/_thumbLoader";
import {SliderArrow} from "@atoms/LinksAndButtons/SliderArrow";
import {keyboardClickable} from "components/hooks/keyboardClickable";
import Slider from "react-slick";
import {SiteModel} from "features/apartmentViewer/ApartmentViewer/models/SiteModel";

interface Props {
    loading: boolean;
    siteData: SiteModel;
    onClick: (thumb: ThumbNailModel) => void;
}

export const ApartmentThumbs : React.FC<Props> = ({loading, siteData, onClick}) => {

    const [activeThumb, setActiveThumb] = useState<string>('');



    const settings = {
        arrows: true,
        nextArrow: <SliderArrow next />,
        prevArrow: <SliderArrow />,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToScroll: 1,
        //afterChange: afterChange,
        //beforeChange: beforeChange,
        draggable: false,
        //centerMode: true,
        //centerPadding: '100px',
        //slidesToShow: 6,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1210,
                settings: {
                    //slidesToShow: 4,
                }
            },{
                breakpoint: 769,
                settings: {
                    arrows: false,
                    //slidesToShow: 1,
                }
            }
        ]
    };


    const getThumbImage = (thumb: ThumbNailModel) => {

        if(!siteData || !thumb) return null;

        const domain = window.location.protocol + '//' + window.location.hostname;

        const src = `${domain}/externalfiles/image/residenceexplorer/${siteData.stageId}/360/${siteData.currentApartment?.id}/${siteData.currentFurnishing}/thumbs/${thumb.id}.jpg`;


        return (
            <img src={src} alt={thumb.title}  />
        );
    };

    const internalOnclick = async (thumb: ThumbNailModel) => {
        if(loading) return;

        setActiveThumb(thumb.id);

        await onClick(thumb);

        setActiveThumb('');
    };

    if(!siteData || !siteData.thumbNails) return null;

    return (
        <Slider {...settings} className="apartment-thumbs">
            {siteData.thumbNails.map((thumb, index) => (
                <div className="apartment-thumbs__thumb" key={`thumb-${index}`} {...keyboardClickable(() => internalOnclick(thumb))}>
                    {activeThumb === thumb.id && <ApartmentThumbLoader />}
                    {activeThumb !== thumb.id && getThumbImage(thumb)}
                </div>
            ))}
        </Slider>
    );
};
